/**
 * Generate avatar initials from a name
 * Example: "Maik van den Hengel" -> "MvdH"
 */
export function getAvatarInitials(name) {
  if (!name || typeof name !== 'string') {
    return '?';
  }

  const words = name.trim().split(/\s+/);
  
  if (words.length === 0) {
    return '?';
  }

  if (words.length === 1) {
    // Single word: take first 2 letters
    return words[0].substring(0, 2).toUpperCase();
  }

  // Multiple words: take first letter of each word
  return words.map(word => word.charAt(0).toUpperCase()).join('');
}

